<mat-icon [matTooltip]="tooltip() | translate" fontIcon="fa-info-circle" fontSet="fad" inline matTooltipClass="large infoHoverTooltip" />
